<template lang="html">
  <section class="distribution-channel-list">
    <distribution-channel
      class="channel"
      v-for="(channel, index) in distributedChannelList"
      :key="index"
      :id="`distribution-channel-${channel.channelId}`"
      :distribution-channel="channel"
      @on-drag-start-widget="onStartDragging"
      @on-drag-end-widget="onEndDragging"
    />
    <div class="loader" v-if="displayLoader"></div>
  </section>
</template>

<script lang="js">
  import { MUTATION_NAME, TOAST_OPTIONS } from "@/static/global-variables";
  import DistributionChannelsService from "@/services/distributionChannelsService";
  import DistributionChannel from "@/components/custom-display-elements/page-elements/DistributionChannel";

  export default  {
    name: "distribution-channel-list",
    components: {
      DistributionChannel
    },
    data() {
      return {
        displayLoader: false
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      distributedChannelList() {
        return this.$store.getters[MUTATION_NAME.DISTRIBUTION_CHANNEL_LIST] || [];
      }
    },
    mounted() {
      if(!this.distributedChannelList.length) {
        this.displayLoader = true;
        DistributionChannelsService.customerDomainList()
        .catch((e) => {
          this.$bvToast.toast(this.getMessageText(this.messages.ERROR_WHILE_LOADING), TOAST_OPTIONS.bottomCenter);
          console.error(e);
        })
        .finally(() => {
          this.displayLoader = false;
        });
      }
    },
    methods: {
      onStartDragging(ctx) {
        this.$emit("on-drag-start", ctx);
      },
      onEndDragging(ctx) {
        this.$emit("on-drag-end", ctx);
      }
    }
  }
</script>

<style scoped lang="scss">
  .distribution-channel-list {
    box-sizing: border-box;
    .channel {
      margin-bottom: 0.4rem;
    }
    .loader {
      width: 1.3rem;
      height: 1.3rem;
    }
  }
</style>
